// src/components/PublicRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  console.log('PublicRoute - Auth Status:', { 
    isAuthenticated: isAuthenticated(), 
    loading 
  });

  // Show loading while checking authentication status
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        backgroundColor: '#f8f9fa'
      }}>
        <div style={{
          padding: '2rem',
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
          Loading...
        </div>
      </div>
    );
  }

  // If already authenticated, redirect to admin portal
  if (isAuthenticated()) {
    console.log('Already authenticated, redirecting to /adminportal');
    return <Navigate to="/adminportal" replace />;
  }

  console.log('Not authenticated, showing login page');
  // If not authenticated, show the login page
  return children;
};

export default PublicRoute;